import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A8F37CBB-10AA-42DE-9CD6-BDCE10C2AF8C
 * name pine-tree-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pine-tree-box.svg
 * tags
 * - Holiday 
 * - Nature 
 * - Agriculture 
 */
export const PineTreeBoxIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M11,19H13V17H18L14,13H17L13,9H16L12,5L8,9H11L7,13H10L6,17H11V19Z" /></>, 'PineTreeBoxIcon');
export default PineTreeBoxIcon